var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { TransferAccountTile } from '@ally/aos-shared-account-select';
import { AccountLabel, Details, Term } from '../shared';
var ToAccountDisplay = function (props) {
    if (props.asTile) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Term, null, "To account"),
            React.createElement(Details, null,
                React.createElement(TransferAccountTile, { id: "toAccount", account: props.account }))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Term, null, "To"),
        React.createElement(Details, null,
            React.createElement(AccountLabel, __assign({}, props)))));
};
export default ToAccountDisplay;
//# sourceMappingURL=Display.js.map